<template>
  <div class="login_wrap">
    <div class="login_bgc">
      <div class="logon_title">WELCOME</div>
      <img src="../../../static/images/bgc.svg" alt="" />
    </div>
    <div class="login_box">
      <h1>智慧运维后台管理系统</h1>
      <h4>欢迎登录</h4>
      <div class="login_form">
        <el-form :model="loginFrom" :rules="loginRules" ref="loginFrom">
          <el-form-item prop="userName">
            <el-input v-model="loginFrom.userName" placeholder="请输入手机号" clearable>
              <i slot="prefix">
                <img src="../../../static/images/zhanghao.svg" alt="" />
              </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginFrom.password" type="password" placeholder="请输入用户登录密码" clearable>
              <i slot="prefix">
                <img src="../../../static/images/mima.svg" alt="" />
              </i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="remember_box">
          <div class="img_box" @click="cutRemember">
            <img v-if="!rememberpwd" src="../../../static/images/login_yuan.png" alt="" />
            <img v-else src="../../../static/images/login_jizhu.png" alt="" />
          </div>
          <span>记住密码</span>
        </div>

        <el-button class="log_btn" @click="submitForm('loginFrom')">登 录</el-button>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setCookie, getCookie, delCookie } from "../../utils/util";
export default {
  name: "login",
  data () {
    return {
      // 记住密码
      rememberpwd: false,
      loginFrom: {
        userName: "",
        password: "",
      },
      //rules前端验证
      loginRules: {
        userName: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入用户登录密码", trigger: "blur" },
        ],
      },
      // imgSrcList: [
      //   "../../../static/qishou.png",
      //   "../../../static/mendian.png",
      //   "../../../static/zichang.png",
      //   "../../../static/yunying.png",
      //   "../../../static/yonghu.png",
      // ],
    };
  },
  created () {
    // 获取存在本地的用户名密码
    this.getuserpwd();
    console.log("1", this.$route);
  },
  methods: {
    // 获取用户名密码
    getuserpwd () {
      if (getCookie("user") != "" && getCookie("pwd") != "") {
        this.loginFrom.userName = getCookie("user");
        this.loginFrom.password = getCookie("pwd");
        this.rememberpwd = true;
      }
    },
    cutRemember () {
      this.rememberpwd = !this.rememberpwd;
    },
    //获取info列表
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          let params = {
            userName: this.loginFrom.userName,
            password: this.loginFrom.password,
            isLastingCookie: this.rememberpwd
          };
          this.$http.login(params).then((res) => {
            console.log("登陆成功", res);
            if (res.code === 0) {
              if (this.rememberpwd) {
                //保存帐号到cookie，有效期7天
                setCookie("user", this.loginFrom.userName, 7);
                //保存密码到cookie，有效期7天
                setCookie("pwd", this.loginFrom.password, 7);
              } else {
                delCookie("user");
                delCookie("pwd");
              }
              sessionStorage.setItem("Token", res.data.token);
              this.$router.push({ path: "/home" });
            } else {
              this.$message.error(res.msg);
              return false;
            }
          });
        } else {
          // this.$message.error("请输入用户登录账号和密码！");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login_wrap {
  width: 100%;
  height: 100vh;
  background: url("../../../static/images/big_bgc.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  position: relative;

  .login_bgc {
    width: 1050px;
    height: 627px;
    margin-left: 187px;
    position: relative;
    background: #ffffff;
    box-shadow: 2px 3px 10px 1px rgba(0, 0, 0, 0.16);
    border-radius: 24px;

    .logon_title {
      position: absolute;
      top: 50px;
      left: 50px;
      font-size: 31px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #255A7E;
      padding-bottom: 14px;
      border-bottom: 6px solid #255A7E;
    }

    >img {
      width: 600px;
      height: 400px;
      position: absolute;
      left: 50%;
      bottom: 80px;
      transform: translateX(-50%);
    }
  }

  .login_box {
    width: 511px;
    height: 548px;
    background: #ffffff;
    box-shadow: 2px 3px 10px 1px rgba(0, 0, 0, 0.16);
    border-radius: 24px;
    z-index: 168;
    position: absolute;
    top: 50%;
    right: 230px;
    transform: translateY(-50%);
    padding: 0 74px;
    box-sizing: border-box;

    h1 {
      color: #255A7E;
      position: absolute;
      top: 48px;
      left: 50%;
      transform: translateX(-50%);
      margin: 0;
      font-size: 24px;
      white-space: nowrap;
    }

    h4 {
      width: 36px;
      margin: 132px 0 0 0;
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #646464;
      padding-bottom: 8px;
      border-bottom: 6px solid #255A7E;
      white-space: nowrap;
    }

    .login_form {
      margin-top: 30px;

      /deep/.el-input {
        position: relative;

        .el-input__prefix {
          position: absolute;
          top: 0;
          left: 10px;
        }
      }

      /deep/.el-input__inner {
        height: 50px;
        line-height: 50px;
        // background: #f4f4f4;
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #9d9d9d;
        padding-left: 40px;
      }

      /deep/.el-input__prefix,
      .el-input__suffix {
        display: flex;
        align-items: center;
        width: 40px;

        i {
          display: flex;
          align-items: center;

          img {
            width: 18px;
            height: 22px;
          }
        }
      }
    }

    .remember_box {
      margin-top: 20px;
      font-size: 16px;
      height: 26px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #9d9d9d;
      display: flex;
      align-items: center;

      .img_box {
        margin-right: 8px;
        height: 100%;
        display: flex;
        align-items: center;

        >img {
          width: 17px;
          height: 17px;
        }
      }
    }

    .log_btn {
      width: 100%;
      height: 50px;
      background: #255A7E;
      box-shadow: 0px 3px 6px 1px rgba(116, 144, 235, 0.46);
      border-radius: 4px;
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      margin-top: 50px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/login.vue